module.exports = __webpack_public_path__ + "f45c51f6849c9707558e8268ab8b10ed.pdf";